<template>
  <main class="korea">
    <Menu />
    <hero />
    <sponsors />
    <agenda />
    <speakers />
    <presenters />
    <partners />
  </main>
</template>

<style lang="scss" scoped>
  @import '@/styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/korea25/menu.vue';
import hero from '@/components/korea25/hero.vue';
import agenda from '@/components/korea25/agenda.vue';
import sponsors from '@/components/korea25/sponsors.vue';
import speakers from '@/components/korea25/speakers.vue';
import presenters from '@/components/korea25/presenters.vue';
import partners from '@/components/korea25/partners.vue';

export default {
  name: 'Home',
  components: {
    Menu,
    hero,
    agenda,
    sponsors,
    presenters,
    speakers,
    partners
  },
};
</script>

<style lang="scss" scoped>
  .korea {
    &#single-schedule {
      padding: 30px 0;
    }
  }
</style>